import { render, staticRenderFns } from "./RefillProductsTableMobile.vue?vue&type=template&id=64f844f8&scoped=true"
import script from "./RefillProductsTableMobile.vue?vue&type=script&lang=js"
export * from "./RefillProductsTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f844f8",
  null
  
)

export default component.exports